var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 13.7497L10.8334 14.583C10.8334 14.583 17.0834 13.333 17.9167 13.333C18.7501 13.333 18.7501 14.1663 17.9167 14.9997C17.0834 15.833 14.1667 18.333 11.6667 18.333C9.16675 18.333 7.50008 17.083 5.83341 17.083H1.66675",
    stroke: "#F8F8F8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 7.49967V4.16634C6.66675 3.94533 6.75455 3.73337 6.91083 3.57709C7.06711 3.42081 7.27907 3.33301 7.50008 3.33301H17.5001C17.7211 3.33301 17.9331 3.42081 18.0893 3.57709C18.2456 3.73337 18.3334 3.94533 18.3334 4.16634V10.833M1.66675 12.083C2.50008 11.2497 4.16675 9.99967 5.83341 9.99967C7.50008 9.99967 11.4584 11.6663 12.0834 12.4997C12.7084 13.333 10.8334 14.583 10.8334 14.583L1.66675 12.083Z",
    stroke: "#F8F8F8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 3.33301H14.5834V7.08301H10.4167V3.33301Z",
    stroke: "#F8F8F8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.b396fb1a.svg";
export { ForwardRef as ReactComponent };